import { createElement, useMemo, type ReactNode } from 'react'
import { useFollowUpKinds } from './useFollowUp'
import { FollowUpRouteActions } from '../components/campaign/followUp/routes/FollowUpRouteActions'
import type { FollowUpKind } from '../types/followUp'

/** CF-1 P2 slot builder for FollowUpTab (merge with mergeSectionSlots): route actions for Sign
 *  drop-offs and every active route-mode custom kind. Chase is left to P5's own builder. */
export function useFollowUpRouteSlots(
  campaignId: string,
): Partial<Record<FollowUpKind | `custom:${string}`, ReactNode>> {
  const { data: kinds } = useFollowUpKinds()
  return useMemo(() => {
    const slots: Partial<Record<FollowUpKind | `custom:${string}`, ReactNode>> = {
      SignDropOff: createElement(FollowUpRouteActions, { campaignId, kind: 'SignDropOff' }),
    }
    for (const k of kinds ?? []) {
      if (!k.isActive || k.mode !== 'Route') continue
      slots[`custom:${k.id}`] = createElement(FollowUpRouteActions, { campaignId, kind: 'Custom', customKindId: k.id })
    }
    return slots
  }, [campaignId, kinds])
}
